(function ($) {
	class W4D_ProductQuantityHelper {
		constructor() {}

		getDecimalPlaces(num) {
			if (!num || Math.floor(num) === num) return 0;
			const parts = num.toString().split('.');

			let result = parts.length > 1 ? parts[1].length : 0;
			if (result > 3) result = 3;

			return result;
		}

		roundToDecimalPlaces(num, places) {
			const multiplier = Math.pow(10, places);
			return Math.round(num * multiplier) / multiplier;
		}

		isDeleteOperation(e) {
			return (
				e &&
				e.originalEvent &&
				(e.originalEvent.inputType === 'deleteContentBackward' || e.originalEvent.inputType === 'deleteContentForward')
			);
		}

		hasLeadingZeroFollowedByDigit(value) {
			return value.length > 1 && value[0] === '0' && value[1] !== '.' && value[1] !== ',' && !isNaN(parseInt(value[1]));
		}

		removeLeadingZero(input, currentValue, cursorPos) {
			const newValue = currentValue.substring(1);
			$(input).val(newValue);
			input.setSelectionRange(cursorPos - 1, cursorPos - 1);
			return newValue;
		}

		removeInvalidCharacters(value) {
			return value.replace(/[^0-9.,]/g, '');
		}

		applyMinimumValue(value) {
			if (parseFloat(value.replace(',', '.')) < 0) {
				return { value: '0', numericValue: 0 };
			}
			return { value, numericValue: parseFloat(value.replace(',', '.')) || 0 };
		}

		applyMaximumValue(value, numericValue, maxValue) {
			if (numericValue > maxValue) {
				const decimalSeparator = value.includes(',') ? ',' : '.';
				return {
					value: String(maxValue).replace('.', decimalSeparator),
					numericValue: maxValue,
				};
			}
			return { value, numericValue };
		}

		calculateNewCursorPosition(input, currentValue, newValue, cursorPos, maxDecimalPlaces) {
			if (
				parseFloat(newValue.replace(',', '.')) === 0 ||
				parseFloat(newValue.replace(',', '.')) === parseFloat($(input).attr('max') || '9999.99')
			) {
				return newValue.length;
			}

			let newCursorPos = cursorPos;

			if (currentValue.length > newValue.length) {
				// Characters were removed
				const beforeCursor = currentValue.substring(0, cursorPos);
				const sanitizedBeforeCursor = this.formatInputValue(this.removeInvalidCharacters(beforeCursor), maxDecimalPlaces);

				const removedBeforeCursor = beforeCursor.length - sanitizedBeforeCursor.length;
				newCursorPos = cursorPos - removedBeforeCursor;
			}

			// Ensure cursor position is within bounds
			return Math.max(0, Math.min(newCursorPos, newValue.length));
		}

		formatInputValue(value, maxDecimalPlaces) {
			// Handle mixed decimal separators (both . and ,)
			if (value.includes('.') && value.includes(',')) {
				const firstDecimalType = value.indexOf('.') < value.indexOf(',') ? '.' : ',';
				const otherDecimalType = firstDecimalType === '.' ? ',' : '.';
				value = value.replace(new RegExp('\\' + otherDecimalType, 'g'), '');
			}

			// Ensure only one decimal separator of the same type
			const decimalCount = (value.match(/[.,]/g) || []).length;
			if (decimalCount > 1) {
				const firstDecimalPos = value.indexOf(',') !== -1 ? value.indexOf(',') : value.indexOf('.');
				const firstPart = value.substring(0, firstDecimalPos + 1);
				const secondPart = value.substring(firstDecimalPos + 1).replace(/[.,]/g, '');
				value = firstPart + secondPart;
			}

			// Limit decimal places based on step
			if (maxDecimalPlaces >= 0 && (value.includes('.') || value.includes(','))) {
				const decimalSeparator = value.includes(',') ? ',' : '.';
				const parts = value.split(decimalSeparator);
				if (parts.length > 1) {
					if (maxDecimalPlaces === 0) {
						// No decimal places allowed for whole number steps
						parts[1] = '';
					} else if (parts[1].length > maxDecimalPlaces) {
						// Truncate to max allowed decimal places
						parts[1] = parts[1].substring(0, maxDecimalPlaces);
					}
					value = parts.join(decimalSeparator);
				}
			}

			return value;
		}

		isEmptyOrLoneDecimalSeparator(value) {
			return value === '' || value === '.' || value === ',';
		}

		isZeroWithoutDecimal(value) {
			return parseFloat(value.replace(',', '.')) === 0 && !value.includes('.') && !value.includes(',');
		}

		validateProductQuantityDirectInput(input, e) {
			if (e && this.isDeleteOperation(e)) {
				const $input = $(input);
				const currentValue = $input.val();

				// Provjerite je li trenutna vrijednost valjana
				if (currentValue === '' || currentValue === '.' || currentValue === ',') {
					return {
						isValid: true,
						valueChanged: false,
						numericValue: 0,
						formattedValue: currentValue,
					};
				}

				// Ako je vrijednost djelomično valjana (npr. "5."), dopustite ju tijekom uređivanja
				if (currentValue.endsWith('.') || currentValue.endsWith(',')) {
					return {
						isValid: true,
						valueChanged: false,
						numericValue: parseFloat(currentValue.replace(',', '.')) || 0,
						formattedValue: currentValue,
					};
				}
			}

			const $input = $(input);
			const maxValue = parseFloat($input.attr('max') || '9999');
			const step = parseFloat($input.attr('step') || 1);
			const cursorPos = input.selectionStart;
			let currentValue = $input.val();
			let valueChanged = false;

			// Determine maximum allowed decimal places based on step
			const maxDecimalPlaces = this.getDecimalPlaces(step);

			// Handle leading zero followed by a digit
			if (this.hasLeadingZeroFollowedByDigit(currentValue)) {
				this.removeLeadingZero(input, currentValue, cursorPos);
				return this.validateProductQuantityDirectInput(input);
			}

			// Remove invalid characters and format the value
			let newValue = this.removeInvalidCharacters(currentValue);
			newValue = this.formatInputValue(newValue, maxDecimalPlaces);

			if (newValue.endsWith('.') || newValue.endsWith(',')) {
				// Ne mijenjajte vrijednost tijekom uređivanja
			} else {
				// Apply minimum value constraint
				let result = this.applyMinimumValue(newValue);
				newValue = result.value;
				let numericValue = result.numericValue;

				// Apply maximum value constraint
				result = this.applyMaximumValue(newValue, numericValue, maxValue);
				newValue = result.value;
				numericValue = result.numericValue;
			}

			// Update value if changed due to sanitization
			if (currentValue !== newValue) {
				valueChanged = true;
				$input.val(newValue);

				// Calculate and set the new cursor position
				const newCursorPos = this.calculateNewCursorPosition(input, currentValue, newValue, cursorPos, maxDecimalPlaces);
				input.setSelectionRange(newCursorPos, newCursorPos);
			}

			// Return validation result
			return {
				isValid: true,
				valueChanged: valueChanged,
				numericValue: parseFloat(newValue.replace(',', '.')) || 0,
				formattedValue: newValue,
			};
		}
	}

	$(document).ready(() => {
		window.W4D_ProductQuantityHelper = new W4D_ProductQuantityHelper();
	});
})(jQuery);
